type Props = {
  status: string;
  busy: boolean;
  onSave: (status: string) => void;
};

const OPTIONS = [
  { value: "OPEN", label: "Ouvert", hint: "Les clients voient les horaires habituels." },
  { value: "CLOSED_TEMPORARILY", label: "Fermé temporairement", hint: "Congés, travaux, pause." },
  { value: "CLOSED_PERMANENTLY", label: "Fermé définitivement", hint: "La fiche reste, sans horaires." },
];

export default function OpenStatus({ status, busy, onSave }: Props) {
  return (
    <div>
      <h3 className="text-lg font-semibold">Ouverture</h3>
      <p className="mt-1 text-sm text-slate-500">Un choix, clairement affiché sur Google.</p>
      <div className="mt-6 grid gap-3">
        {OPTIONS.map((o) => (
          <button
            key={o.value}
            type="button"
            disabled={busy}
            onClick={() => onSave(o.value)}
            className={`rounded-2xl border px-5 py-4 text-left ${
              status === o.value ? "border-violet bg-violet/5" : "border-slate-200 hover:border-violet/30"
            }`}
          >
            <span className="block text-sm font-semibold">{o.label}</span>
            <span className="mt-1 block text-xs text-slate-500">{o.hint}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
